
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
    faArrowUpFromBracket, 
    faCartShopping, 
    faCheck, 
    faChevronLeft, 
    faChevronDown, 
    faChevronRight, 
    faChevronUp, 
    faCirclePlay, 
    faCircleRight, 
    faCircleQuestion, 
    faCircleXmark,
    faCopy,
    faEllipsisVertical, 
    faEnvelope,
    faHeart, 
    faMinus, 
    faPlus, 
    faUpRightFromSquare, 
    faTrash } from '@fortawesome/free-solid-svg-icons';
library.add(
    faArrowUpFromBracket, 
    faCartShopping, 
    faCheck, 
    faChevronLeft, 
    faChevronDown, 
    faChevronRight, 
    faChevronUp, 
    faCirclePlay, 
    faCircleRight, 
    faCircleQuestion, 
    faCircleXmark, 
    faCopy, 
    faEllipsisVertical, 
    faEnvelope,
    faHeart, 
    faMinus, 
    faPlus, 
    faUpRightFromSquare, 
    faTrash
);